import { LanguageService } from './../services/language.service';
import { Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NgForOf } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: true,
  imports: [NgForOf],
})
export class LanguageSelectorComponent {
  public languages = this.languageService.getLanguages();

  private currentLang = 'en';

  constructor(private authService: AuthService,
              private languageService: LanguageService) {
  }

  public setLanguage(lang: string): void {
    this.authService.setUserLanguage(lang);
    this.currentLang = lang;
  }

  public addClass(lang: string) {
    let activeItem = false;
    if (this.authService.isUserLoggedIn() && this.authService.getUserInfo()){
      if (this.authService.getUserInfo().language === lang){
        activeItem = true;
      }
    } else if (lang === this.currentLang) {
      activeItem = true;
    }
    return (activeItem ? 'dropdown-item active'  : 'dropdown-item');
  }
}
